export class CompiledAdvancedDailyEngagedUserConsumption {
  dateReference!: string | Date;
  userConversation!: number;
  prospectConversation!: number;

  constructor(compiledAdvancedDailyEngagedUserConsumption: Partial<CompiledAdvancedDailyEngagedUserConsumption | null>) {
    Object.assign(this, compiledAdvancedDailyEngagedUserConsumption);
  }
}
